// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__6pPV-","icons":"Footer_icons__a5Ims","icon":"Footer_icon__mXqd6"};